import { z } from 'zod';
import { moneySchema } from './schemas.js';

export const documentLineSchema = z.object({
  description: z.string().max(500).optional(),
  quantity: z.coerce.number().positive().default(1),
  unitPrice: moneySchema,
  taxRatePercent: z.coerce.number().min(0).max(100).default(0)
});

export const salesInvoiceDraftSchema = z.object({
  customerId: z.string().min(1),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  memo: z.string().max(1000).optional(),
  periodId: z.string().min(1),
  lines: z.array(documentLineSchema).min(1)
});

export const purchaseBillDraftSchema = z.object({
  vendorId: z.string().min(1),
  date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
  dueDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  memo: z.string().max(1000).optional(),
  periodId: z.string().min(1),
  lines: z.array(documentLineSchema).min(1)
});

export const DEFAULT_SUBLEDGER_ACCOUNTS = {
  cash: '1000',
  ar: '1200',
  ap: '2000',
  revenue: '4000',
  cogs: '5000',
  expense: '6000',
  vatPayable: '2100',
  inventory: '1300'
} as const;

export type DocumentLine = z.infer<typeof documentLineSchema>;
export type SalesInvoiceDraft = z.infer<typeof salesInvoiceDraftSchema>;
export type PurchaseBillDraft = z.infer<typeof purchaseBillDraftSchema>;
